import { Dictionary } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { GroupTitleTemplate } from "@ryde/controls";
import {
  GenericUploadColumnConflictError,
  IGenericUploadColumnConflict,
} from "@ryde/shared";

import { ResolveColumnConflictsTable } from "./components";
import { GenericUploadColumnConflictsContext } from "./contexts";

interface IGenericUploadColumnConflictsProps {
  conflicts: Dictionary<IGenericUploadColumnConflict[]>;
}

export const GenericUploadColumnConflicts: FC<
  IGenericUploadColumnConflictsProps
> = ({ conflicts }) => {
  const { t } = useTranslation();

  return (
    <>
      <GroupTitleTemplate
        name="column-conflicts"
        formLabel={t("genericUpload.columnConflicts")}
      />
      {(Object.keys(conflicts) as GenericUploadColumnConflictError[]).map(
        errorType => {
          return (
            <GenericUploadColumnConflictsContext.Provider
              key={errorType}
              value={{
                conflicts: conflicts[errorType],
              }}
            >
              <ResolveColumnConflictsTable errorType={errorType} />
            </GenericUploadColumnConflictsContext.Provider>
          );
        },
      )}
    </>
  );
};
